/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import {
  EntityId,
  InviteUsersAndTeams,
  List,
  MemberRole,
  MemberRoleOrGuest,
  OrganizationTeam,
  UserContentPermission,
} from "./data-contracts";

/**
 * No description
 * @tags collection-permissions
 * @name InviteToCollection
 * @summary Invite to a collection
 * @request POST:/collections/{collectionId}/permissions
 * @secure
 */

// @ts-ignore
export const inviteToCollection: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the collection */
    collectionId: EntityId;
  };
  RequestQuery: {};
  RequestBody: InviteUsersAndTeams;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 404;
} = {
  route: "/collections/{collectionId}/permissions",
  method: "post",
  streaming: false,
  tags: ["collection-permissions"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags collection-permissions
 * @name ListTeamPermissionsInCollection
 * @summary List an org team's permission in collection
 * @request GET:/collections/{collectionId}/permissions/teams
 * @secure
 */

// @ts-ignore
export const listTeamPermissionsInCollection: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the collection */
    collectionId: EntityId;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: {
      /**
       * "The role of a member in an organization.
       * "admin": Can administrate the content: create, delete spaces, ...
       * "create": Can create content.
       * "review": Can review content.
       * "edit": Can edit the content (live or change requests).
       * "comment": Can access the content and its discussions.
       * "read": Can access the content, but cannot update it in any way.
       */
      permission: MemberRole;
      team: OrganizationTeam;
    }[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/collections/{collectionId}/permissions/teams",
  method: "get",
  streaming: false,
  tags: ["collection-permissions"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags collection-permissions
 * @name UpdateTeamPermissionInCollection
 * @summary Update an org team's permission in a collection
 * @request PATCH:/collections/{collectionId}/permissions/teams/{teamId}
 * @secure
 */

// @ts-ignore
export const updateTeamPermissionInCollection: {
  route: string;
  method: "patch";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the collection */
    collectionId: EntityId;
    /** The unique ID of the Team */
    teamId: EntityId;
  };
  RequestQuery: {};
  RequestBody: {
    /** The role of a member in an organization, null for guests */
    role?: MemberRoleOrGuest;
  };
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 404;
} = {
  route: "/collections/{collectionId}/permissions/teams/{teamId}",
  method: "patch",
  streaming: false,
  tags: ["collection-permissions"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags collection-permissions
 * @name RemoveTeamFromCollection
 * @summary Remove an org team from a collection
 * @request DELETE:/collections/{collectionId}/permissions/teams/{teamId}
 * @secure
 */

// @ts-ignore
export const removeTeamFromCollection: {
  route: string;
  method: "delete";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the collection */
    collectionId: EntityId;
    /** The unique ID of the Team */
    teamId: EntityId;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205;
} = {
  route: "/collections/{collectionId}/permissions/teams/{teamId}",
  method: "delete",
  streaming: false,
  tags: ["collection-permissions"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags collection-permissions
 * @name ListUserPermissionsInCollection
 * @summary List collection user permissions
 * @request GET:/collections/{collectionId}/permissions/users
 * @secure
 */

// @ts-ignore
export const listUserPermissionsInCollection: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the collection */
    collectionId: EntityId;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: UserContentPermission[];
  };
  ResponseStatusCode: 200 | 404;
} = {
  route: "/collections/{collectionId}/permissions/users",
  method: "get",
  streaming: false,
  tags: ["collection-permissions"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags collection-permissions
 * @name UpdateUserPermissionInCollection
 * @summary Update a collection user permission
 * @request PATCH:/collections/{collectionId}/permissions/users/{userId}
 * @secure
 */

// @ts-ignore
export const updateUserPermissionInCollection: {
  route: string;
  method: "patch";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the collection */
    collectionId: EntityId;
    /** The unique ID of the User */
    userId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /** The role of a member in an organization, null for guests */
    role?: MemberRoleOrGuest;
  };
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 404;
} = {
  route: "/collections/{collectionId}/permissions/users/{userId}",
  method: "patch",
  streaming: false,
  tags: ["collection-permissions"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags collection-permissions
 * @name RemoveUserFromCollection
 * @summary Remove a user from a collection
 * @request DELETE:/collections/{collectionId}/permissions/users/{userId}
 * @secure
 */

// @ts-ignore
export const removeUserFromCollection: {
  route: string;
  method: "delete";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the collection */
    collectionId: EntityId;
    /** The unique ID of the User */
    userId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205;
} = {
  route: "/collections/{collectionId}/permissions/users/{userId}",
  method: "delete",
  streaming: false,
  tags: ["collection-permissions"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};
